"use client";
import { Card, Divider, Stack, SxProps, Theme, useScrollTrigger } from "@mui/material";
import { Box } from "@mui/system";
import MobileSortChip from "./MobileSortChip";
import MobileFilterChips from "./MobileFilterChips";
import useEmblaCarousel from "embla-carousel-react";
import { usePrevNextButtons } from "@/lib/usePrevNextButtons";
import MobileSearchedTextChip from "./MobileSearchedTextChip";
import { useAppContext } from "../AppProvider";

export default function MobileSearchFilters({ sx }: { sx?: SxProps<Theme> | undefined }) {
  const trigger = useScrollTrigger({});
  const { hasBanner, bannerOptions } = useAppContext();

  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, direction: "rtl", dragFree: true, align: "start" });
  const { nextBtnDisabled, prevBtnDisabled } = usePrevNextButtons(emblaApi as any);
  return (
    <Stack
      gap={1}
      direction={"row"}
      alignItems={"center"}
      sx={(theme) => ({
        ...(sx as any),
        background: theme.palette.background.default,
        zIndex: 2,
        position: "sticky",
        transition: "0.1s all ",
        width: "100%",
        borderBottom: "1px",
        borderBottomStyle: "solid",
        borderBottomColor: "transparent",
        top: {
          xs: 44 + (hasBanner ? bannerOptions.sx.minHeight.xs : 0),
          xsm: 48 + (hasBanner ? bannerOptions.sx.minHeight.xs : 0),
          sm: 48 + (hasBanner ? bannerOptions.sx.minHeight.sm : 0),
          md: 72 + (hasBanner ? bannerOptions.sx.minHeight.md : 0),
        },
        ...(trigger && {
          borderBottomColor: theme.palette.grey["100"],
        }),
      })}
    >
      <Box sx={(theme) => ({ py: { xs: 0.5, sm: 1 }, gap: 1, display: "flex", alignItems: "center", width: "100%", flexShrink: 1 })}>
        <MobileSortChip nextBtnDisabled={nextBtnDisabled} prevBtnDisabled={prevBtnDisabled} />
        <Divider flexItem orientation="vertical" variant="middle" />
        <Card elevation={0} sx={{ background: "transparent", flexGrow: 1 }}>
          <MobileFilterChips
            emblaApi={emblaApi as any}
            emblaRef={emblaRef}
            nextBtnDisabled={nextBtnDisabled}
            prevBtnDisabled={prevBtnDisabled}
          />
        </Card>
      </Box>
    </Stack>
  );
}
